module.exports = __webpack_public_path__ + "img/bars-solid.bb67d775.svg";